import type { FC } from "react";

import SuccessImage from "../../../../../common-components/GrandAccessBanner/SuccessImage";

import { ModalBody, SuccessImageWrapper, SuccessSubtitle, SuccessTitle } from "./styles";

interface ModalContentProps {
    title: string;
    subTitle: string;
}

export const SuccessBannerContent: FC<ModalContentProps> = ({ title, subTitle }) => {
    return (
        <ModalBody>
            <div>
                <SuccessImageWrapper>
                    <SuccessImage />
                </SuccessImageWrapper>
                <SuccessTitle>{title}</SuccessTitle>
                <SuccessSubtitle>{subTitle}</SuccessSubtitle>
            </div>
        </ModalBody>
    );
};
